import queryString from "querystring";

export default (params = {}) => {
    const isEmpty = params && Object.keys(params).length === 0;
    return isEmpty ? "" : `?${queryString.stringify(params)}`;
};
